import { render, staticRenderFns } from "./parsingUpload.vue?vue&type=template&id=25864e84"
import script from "./parsingUpload.vue?vue&type=script&lang=js"
export * from "./parsingUpload.vue?vue&type=script&lang=js"
import style0 from "./parsingUpload.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports